var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 12.25C10.5001 11.0123 10.0084 9.82534 9.13325 8.95017C8.25808 8.075 7.07109 7.58333 5.83341 7.58333C4.59574 7.58333 3.40875 8.075 2.53358 8.95017C1.65841 9.82534 1.16675 11.0123 1.16675 12.25",
    stroke: "#6F8AF4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83342 7.58333C7.44425 7.58333 8.75008 6.2775 8.75008 4.66667C8.75008 3.05584 7.44425 1.75 5.83342 1.75C4.22258 1.75 2.91675 3.05584 2.91675 4.66667C2.91675 6.2775 4.22258 7.58333 5.83342 7.58333Z",
    stroke: "#6F8AF4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 11.6667C12.8334 9.70083 11.6667 7.875 10.5 7C10.8835 6.71228 11.1902 6.33447 11.3929 5.89999C11.5956 5.46551 11.688 4.98777 11.6621 4.50905C11.6361 4.03033 11.4925 3.56538 11.2441 3.15537C10.9956 2.74535 10.6499 2.4029 10.2375 2.15833",
    stroke: "#6F8AF4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team_icon.4c98eb6a71ed72d6bd4f34da3c33d592.svg";
export { ForwardRef as ReactComponent };